__turbopack_context__.v({
  "audition": "product-catalog-module__GJIiWa__audition",
  "back": "product-catalog-module__GJIiWa__back",
  "badgeLabel": "product-catalog-module__GJIiWa__badgeLabel",
  "brandLogo": "product-catalog-module__GJIiWa__brandLogo",
  "card": "product-catalog-module__GJIiWa__card",
  "cardAction": "product-catalog-module__GJIiWa__cardAction",
  "cardPhoto": "product-catalog-module__GJIiWa__cardPhoto",
  "cardText": "product-catalog-module__GJIiWa__cardText",
  "categoryArt": "product-catalog-module__GJIiWa__categoryArt",
  "condition": "product-catalog-module__GJIiWa__condition",
  "conditionRow": "product-catalog-module__GJIiWa__conditionRow",
  "description": "product-catalog-module__GJIiWa__description",
  "detailCard": "product-catalog-module__GJIiWa__detailCard",
  "detailCategory": "product-catalog-module__GJIiWa__detailCategory",
  "detailDialog": "product-catalog-module__GJIiWa__detailDialog",
  "detailHeading": "product-catalog-module__GJIiWa__detailHeading",
  "detailPrice": "product-catalog-module__GJIiWa__detailPrice",
  "detailTop": "product-catalog-module__GJIiWa__detailTop",
  "detailWrap": "product-catalog-module__GJIiWa__detailWrap",
  "detailsBody": "product-catalog-module__GJIiWa__detailsBody",
  "detailsButton": "product-catalog-module__GJIiWa__detailsButton",
  "detailsIcon": "product-catalog-module__GJIiWa__detailsIcon",
  "empty": "product-catalog-module__GJIiWa__empty",
  "filter": "product-catalog-module__GJIiWa__filter",
  "galleryCaption": "product-catalog-module__GJIiWa__galleryCaption",
  "galleryDialog": "product-catalog-module__GJIiWa__galleryDialog",
  "galleryPhoto": "product-catalog-module__GJIiWa__galleryPhoto",
  "galleryStage": "product-catalog-module__GJIiWa__galleryStage",
  "galleryTop": "product-catalog-module__GJIiWa__galleryTop",
  "heading": "product-catalog-module__GJIiWa__heading",
  "headingLogo": "product-catalog-module__GJIiWa__headingLogo",
  "iconButton": "product-catalog-module__GJIiWa__iconButton",
  "leadPhoto": "product-catalog-module__GJIiWa__leadPhoto",
  "morePhotos": "product-catalog-module__GJIiWa__morePhotos",
  "page": "product-catalog-module__GJIiWa__page",
  "photoGrid": "product-catalog-module__GJIiWa__photoGrid",
  "pricing": "product-catalog-module__GJIiWa__pricing",
  "productList": "product-catalog-module__GJIiWa__productList",
  "sidePhoto": "product-catalog-module__GJIiWa__sidePhoto",
  "standaloneCard": "product-catalog-module__GJIiWa__standaloneCard",
  "thumbnails": "product-catalog-module__GJIiWa__thumbnails",
  "unit": "product-catalog-module__GJIiWa__unit",
});
